import { useContext } from "react";
import { ComboBoxStateContext } from "react-aria-components";

import { Cross } from "components/icons/generated";

import ButtonIcon from "../ButtonIcon";

type ComboBoxClearButtonProps = {
  isDisabled?: boolean;
};
const ComboBoxClearButton = ({ isDisabled }: ComboBoxClearButtonProps) => {
  const state = useContext(ComboBoxStateContext);

  if (state?.inputValue === "") {
    return null;
  }

  return (
    <ButtonIcon
      // Don't inherit default Button behavior from ComboBox.
      variant="ghost"
      slot={null}
      aria-label="Clear"
      icon={Cross}
      disabled={isDisabled}
      excludeFromTabOrder
      onPress={() => {
        // ComboBoxMultiple hardcodes selectedKey to null, so setSelectedKey(null) there is a
        // no-op — clear the input text directly so this also works for multi-select.
        state?.setSelectedKey(null);
        state?.setInputValue("");
      }}
    >
      Clear
    </ButtonIcon>
  );
};

ComboBoxClearButton.displayName = "DS.ComboBox.ClearButton";

export default ComboBoxClearButton;
